import { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'

export class ShowCasePeriodEntity {
  id?: string
  startTime?: string
  startTimeDayOfWeek?: DayOfWeek
  endTime?: string
  endTimeDayOfWeek?: DayOfWeek
}
